// @flow
import React, { PureComponent } from "react"
import { connect } from "react-redux"
import { NONE } from "@kiwicom/nitro/lib/consts/modals"

import ModalBody from "../ModalBody/ModalBody"
import SubscriptionModal from "../../../../app/scripts/modules/Auth/SubscriptionModal"
import CreatingPasswordModal from "../../../../app/scripts/modules/Auth/CreatingPasswordModal"
import ChatModal from "../../../../app/scripts/modules/Chat/ChatModal"
import DebugModal from "../../../../app/scripts/modules/Debug/DebugModal"
import { showModal, hideModal as _hideModal } from "../../services/modals/actions"
import { removeBanner as _removeBanner } from "../../services/remoteConfig/actions"
import InfoModal from "../InfoModal/InfoModal"
import Translate from "../../../../app/scripts/components/Translate"
import AlertModal from "../AlertModal/AlertModal"
import { bannersConfigSelector } from "../../services/remoteConfig"
import type { BannersConfig } from "../../services/remoteConfig"
import { windowTypeSelector } from "../../services/window"
import { handleBlockScrollBody } from "common/utils/scrollUtils"
import DelayedChat from "../DelayedChat/DelayedChat"
import type { ModalsState } from "../../services/modals/reducer"
import type { ModalType } from "../../services/modals/actions"
import maybeTranslate from "../../../../app/scripts/tools/maybeTranslate"
import {
  handleClosedBannerCookies,
  shouldShowAlert,
} from "../../services/remoteConfig/bannerHelper"
import type { WindowType } from "common/consts/windowConsts"
import * as nitroSideEffects from "../../utils/nitroSideEffects"
import LoginModal from "../LoginModal/LoginModal"

type Props = {
  modals: ModalsState,
  banner: {
    text: Array<string>,
    showOnMobile: boolean,
  },
  open: string => void,
  close: string => void,
  hideModal: string => void,
  removeBanner: number => void,
  windowType: WindowType,
  bannersConfig: BannersConfig,
}

class Modals extends PureComponent<Props> {
  closeSingleAlert = (bannersConfig, index) => {
    const { hideModal, removeBanner } = this.props

    if (bannersConfig.banners.length === 1) {
      hideModal("exponea")
    }

    removeBanner(index)
  }

  handleCloseKeyDown = (ev: KeyboardEvent, modal: ModalsState) => {
    const { close } = this.props

    if (ev.keyCode === 13) {
      close(modal)
    } else if (ev.keyCode === 32) {
      ev.preventDefault() // to prevent default scrolling down the modal
      close(modal)
    }
  }

  render() {
    const { close, open, modals, bannersConfig, windowType } = this.props

    if (modals.get("login")) {
      const initialScreen = modals.getIn(["login", "activeTab"])
      const type = modals.getIn(["login", "type"])
      const disableSocialLogin = modals.getIn(["login", "disableSocialLogin"]) || false
      const onClose = () => {
        nitroSideEffects.modals(NONE)
        close("login")
      }

      return (
        <LoginModal
          type={type}
          disableSocialLogin={disableSocialLogin}
          initialScreen={initialScreen}
          onClose={onClose}
        />
      )
    }

    if (modals.get("signUpConfirm")) {
      return (
        <ModalBody
          onClose={() => close("signUpConfirm")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "signUpConfirm")}
        >
          <InfoModal onClose={() => close("signUpConfirm")}>
            <Translate tKey="account.check_your_email" />
          </InfoModal>
        </ModalBody>
      )
    }
    if (modals.get("creatingPassword")) {
      return (
        <ModalBody
          onClose={() => close("creatingPassword")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "creatingPassword")}
        >
          <CreatingPasswordModal
            {...modals.get("creatingPassword").toObject()}
            onClose={() => close("creatingPassword")}
          />
        </ModalBody>
      )
    }
    if (modals.get("verifyEmail")) {
      return (
        <ModalBody
          onClose={() => close("verifyEmail")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "verifyEmail")}
        >
          <InfoModal onClose={() => close("verifyEmail")}>
            <Translate tKey="account.email_verified" />
          </InfoModal>
        </ModalBody>
      )
    }
    if (modals.get("errorModal")) {
      const params = modals.get("errorModal").toObject()
      return (
        <ModalBody
          onClose={() => close("errorModal")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "errorModal")}
        >
          <InfoModal onClose={() => close("errorModal")}>
            {params.translate ? <Translate tKey={params.error} /> : <span>{params.error}</span>}
          </InfoModal>
        </ModalBody>
      )
    }
    if (modals.get("subscription")) {
      return (
        <ModalBody
          onClose={() => close("subscription")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "subscription")}
          passedClasses="SubscriptionModal"
          closeOnOverlayClick
        >
          <SubscriptionModal
            {...modals.get("subscription").toObject()}
            onClose={() => close("subscription")}
          />
        </ModalBody>
      )
    }
    if (modals.get("debug")) {
      return (
        <ModalBody
          onClose={() => close("debug")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "debug")}
          wide
        >
          <DebugModal {...modals.get("debug").toObject()} onClose={() => close("debug")} />
        </ModalBody>
      )
    }
    if (modals.get("delayedChat")) {
      return (
        <ModalBody
          passedClasses="Modal-DelayedChat"
          onClose={() => close("delayedChat")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "delayedChat")}
        >
          <DelayedChat
            onOpenChat={() => open("chat")}
            onCloseHandler={() => close("delayedChat")}
          />
        </ModalBody>
      )
    }
    if (modals.get("chat")) {
      return (
        <ModalBody
          onClose={() => close("chat")}
          onKeyDown={ev => this.handleCloseKeyDown(ev, "chat")}
        >
          <ChatModal {...modals.get("chat").toObject()} onClose={() => close("chat")} />
        </ModalBody>
      )
    }
    if (modals.get("exponea")) {
      const showAlerts = shouldShowAlert(windowType, bannersConfig)
      const translatedBannerText = bannersConfig.banners.map(maybeTranslate)

      return (
        <div className="Modals-RemoteConfigWrapper">
          {modals.get("exponea") && showAlerts && (
            <AlertModal
              bannerText={translatedBannerText}
              onClose={index => this.closeSingleAlert(bannersConfig, index)}
            />
          )}
        </div>
      )
    }

    return <div className="no-modal" />
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    modals: state.modals,
    bannersConfig: bannersConfigSelector(state),
    windowType: windowTypeSelector(state),
  }),
  dispatch => ({
    open: (modalName: ModalType) => {
      dispatch(showModal(modalName))
    },
    close: (modalName: ModalType) => {
      handleBlockScrollBody(false)
      dispatch(_hideModal(modalName))
    },
    hideModal: (modalName: ModalType) => {
      dispatch(_hideModal(modalName))
    },
    removeBanner: (index: number) => {
      handleClosedBannerCookies(index)
      dispatch(_removeBanner(index))
    },
  }),
)(Modals)
